module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/core-js/modules/_html.js
// module id = 20Vv
// module chunks = 1